import { useContext, useEffect, useState } from "react";
import "./styles.css";
import { ThemeContext } from "../../App";

//useState
//useReducer -> complex state

const Search = (props) => {
  const [inputValue, setInputValue] = useState(""); //initial value

  const { getDataFromSearchComponent, apiCalledSuccess, setApiCalledSuccess } =
    props;

  const { theme } = useContext(ThemeContext);

  const handleInputValue = (event) => {
    const { value } = event.target;

    //set the updated state
    setInputValue(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    getDataFromSearchComponent(inputValue);
  };

  useEffect(() => {
    if (apiCalledSuccess) {
      setInputValue("");
      setApiCalledSuccess(false);
    }
  }, [apiCalledSuccess, setApiCalledSuccess]);

  return (
    <form onSubmit={handleSubmit} className="Search">
      <input
        type="text"
        onChange={handleInputValue}
        value={inputValue}
        name="search"
        placeholder="Search recipes"
      />
      <button
        style={
          theme
            ? {
                backgroundColor: "#fafafa",
                color: "#000",
                border: "1px solid #cecece",
              }
            : {}
        }
        type="submit"
      >
        Search
      </button>
    </form>
  );
};

export default Search;
